/** @jsxImportSource @emotion/react */

import { gradientBackground, headlines } from './VitafyAboutUsPage';

const CustomersBanner: React.FC = () => {
  const text = 'Mehr als *eine Million* \\\\ zufriedener Kunden';
  const divs = splitStringToDivs(text);

  return (
    <div
      css={{
        ...gradientBackground,
        ...headlines.h3,
        color: 'white',
        margin: '4rem 0',
        padding: '3rem 0',
        textAlign: 'center'
      }}
    >
      {divs}
    </div>
  );
};

const highlightStyle = {
  color: 'gold'
};

function splitStringToDivs(input: string): JSX.Element[] {
  return input.split('\\\\').map((part, index) => {
    const partsWithHighlight = part.split(/(\*.*?\*)/).map((subPart, subIndex) => {
      if (subPart.startsWith('*') && subPart.endsWith('*')) {
        return (
          <span key={subIndex} css={highlightStyle}>
            {subPart.slice(1, -1)}
          </span>
        );
      }
      return subPart;
    });

    return <div key={index}>{partsWithHighlight}</div>;
  });
}
export default CustomersBanner;
